/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import "./layout.module.css"
import { StickyContainer } from "react-sticky"
import Header from "./header"
import SEO from "./seo"
import Footer from "./footer"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            metaTitle
            metaDescription
          }
        }
      }
    `}
    render={data => (
      <StickyContainer>
        <SEO title={data.site.siteMetadata.metaTitle} description={data.site.siteMetadata.metaDescription} />
        <Header siteTitle={data.site.siteMetadata.title} />
        {children(data)}
        <Footer />
      </StickyContainer>
    )}
  />
)

export default Layout
